export function getAll(fetch, modelo, txt, all) {
  return fetch().post(`/${modelo}/getlist`, { txt, all: !!all });
}

export function getById(fetch, modelo, isPk, id) {
  return fetch().post(`/${modelo}/${isPk ? "getpk" : "get"}/${id}`);
}

export function save(fetch, modelo, dados) {
  return fetch().post(`/${modelo}/save`, { ...dados, imgUrl: null });
}

export function del(fetch, modelo, id) {
  return fetch().post(`/${modelo}/del/${id}`);
}
